export default "__VITE_ASSET__pmk$0iPswIZHmViN3BCfGQ__"